var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{ref:"txtArea",staticStyle:{"border":"1px solid #000"},attrs:{"value":_vm.value,"label":_vm.lbl,"outline":_vm.outline,"lang":_vm.idioma === 0 ? 'pt-br' : (_vm.idioma === 1) ? 'en-us' : 'es-ES',"pattern":"\\d*","inputmode":"decimal"},on:{"input":_vm.handleInput,"paste":(evt) => _vm.$validateOnlyNumbers(evt, true, _vm.idioma),"click":function($event){_vm.parseString(_vm.input.valor, _vm.idioma) === 0
        ? (_vm.input.valor = '')
        : ''},"keypress":(val) => _vm.onlyFloat(val, _vm.input, 'valor'),"change":(evt) => {
        _vm.limpezaDeDados(_vm.input, 0, _vm.calculo1, [_vm.animal]);
        }}})
}
var staticRenderFns = []

export { render, staticRenderFns }